import React from "react";
import { useTranslation } from "react-i18next";
import locationsData from "../../i18n/hong_kong_locations.json"; // Import the locations JSON

const RegionSelector = ({ SelectedLocations, setSelectedLocations }) => {
  const { t } = useTranslation();

  // Extract regions and their areas from the JSON data
  const regions = locationsData.regions.map((region) => ({
    value: region.value,
    display: region.display[t("language")], // Use current language from i18n
    areas: region.areas.map((area) => ({
      value: area.value,
      display: area.display[t("language")], // Localized area display
    })),
  }));
  // Create a map for easier access to areas based on selected region
  const areaMap = {};
  regions.forEach((region) => {
    areaMap[region.display] = region.areas;
  });

  const handleToggle = (areaValue) => {
    setSelectedLocations((prev) =>
      prev.includes(areaValue)
        ? prev.filter((r) => r !== areaValue)
        : [...prev, areaValue]
    );
  };
  return (
    <div>
      <label>{t("ad.locations")}</label>
      <div className=" ">
        {regions.map((region) => (
          <div key={region.value} className="flex">
            <div className="mt-3  ml-1 p-1  ">{region.display}</div>
            <div className="flex flex-wrap mt-1">
              {region.areas.map((area) => (
                <span
                  key={area.value}
                  onClick={() => handleToggle(area.value)}
                  className={`Select-tag   ${
                    SelectedLocations.includes(area.value)
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                >
                  {area.display}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegionSelector;
